import React, { type FC, type PropsWithChildren } from "react";
import {
	Helmet as HelmetAsync,
	HelmetProvider as HelmetProviderAsync,
} from "react-helmet-async";

// This is a work around! The component library and the front end app must be using the context provided from the same instance (not just version) of react-helmet-async.
// This is because the context is created using the createContext function from react, which creates a new context instance every time it is called.
// This means that the context provided by the component library is different to the context provided by the front end app.
// This is a problem because the context is used to provide the Helmet component with the context it needs to work.
// The solution is to use the same instance of react-helmet-async in both the component library and the front end app.
// This is done by using the react-helmet-async package in the front end app and the react-helmet-async package in the component library.
// This way, the context provided by the component library is the same as the context provided by the front end app.

export const HelmetProvider: FC<PropsWithChildren> = ({ children }) => {
	return <HelmetProviderAsync>{children}</HelmetProviderAsync>;
};

export const Helmet: FC<PropsWithChildren> = ({ children }) => {
	return <HelmetAsync>{children}</HelmetAsync>;
};
